<div style="width: 100%; height: 100%;">
  <absg-password-reset (signInClicked)="logIn()" (cancelClicked)="cancel()"></absg-password-reset>
</div>
